import { render, staticRenderFns } from "./SidebarBottom.vue?vue&type=template&id=1024d008&scoped=true"
import script from "./SidebarBottom.vue?vue&type=script&lang=js"
export * from "./SidebarBottom.vue?vue&type=script&lang=js"
import style0 from "./SidebarBottom.vue?vue&type=style&index=0&id=1024d008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024d008",
  null
  
)

export default component.exports